import React from "react";

// Components
import { Wrapper, SectionCard, NoDataRow, Table, Row, TableHeader, Cell } from "./AssociatedVirtualKits.styles";
import { Link, useParams } from "react-router-dom";
import { HeaderText } from "../../FulfillmentProductCreatePage/Header/Header.styles";

// Helpers
import { get } from "lodash-es";

// Hooks
import { Product } from "../../../../interfaces/products";
import { Spin } from "antd";

interface Props {
  virtualKits: Product["virtual_kits"];
  loading: boolean;
}

const AssociatedVirtualKits: React.FC<Props> = ({ virtualKits, loading }) => {
  const params: { organization_id: string } = useParams();
  const { organization_id: organizationID } = params;
  const tableRows = virtualKits
    ? virtualKits.map((virtualKit) => (
        <Row key={get(virtualKit, "id")}>
          <Cell>
            <Link to={`/organizations/${organizationID}/products/${get(virtualKit, "id")}`}>
              {get(virtualKit, "sku", "-")}
            </Link>
          </Cell>
          <Cell>{get(virtualKit, "name", "-")}</Cell>
          <Cell>{get(virtualKit, "quantity_per_kit", 0)}</Cell>
        </Row>
      ))
    : [];

  return (
    <Wrapper>
      <HeaderText margin="0 0 16px">ASSOCIATED VIRTUAL KITS</HeaderText>
      <Spin spinning={loading}>
        <SectionCard>
          <Table cellPadding="10px">
            <tbody>
              <Row>
                <TableHeader>SKU</TableHeader>
                <TableHeader>Virtual Kit Name</TableHeader>
                <TableHeader>QTY per Kit</TableHeader>
              </Row>
              {tableRows && tableRows.length ? tableRows : null}
            </tbody>
          </Table>
          {tableRows && tableRows.length === 0 ? <NoDataRow>No Associated Virtual Kits</NoDataRow> : null}
        </SectionCard>
      </Spin>
    </Wrapper>
  );
};

export default AssociatedVirtualKits;
